export const inEnglandQuestion = 'In England?';
export const NHSLoginError = 'Something went wrong. Please try again.';
